// extracted by mini-css-extract-plugin
export default {"formContainer":"PatientsDetail_formContainer__KFck2","inputs":"PatientsDetail_inputs__ieC6j","btnEdit":"PatientsDetail_btnEdit__KMAHS","endBtn":"PatientsDetail_endBtn__NLSCo"};